import { READ, UPDATE, DELETE, SET_MAIN_PAGINATION_TOTAL } from '../../../../store/type'
import { MAIN_ADDRESS } from "./type";
import { api } from "../../../../util/api";
import { API_METHODS } from "../../../../constant";

export const actions = {

    [MAIN_ADDRESS + READ]: async({ state, rootState, commit }, paramsIn = null) => {
        try {
            if (paramsIn.id) {
                return await api(API_METHODS.GET_ADDRES, paramsIn, rootState)
            } else {
                const res = await api(API_METHODS.GET_ALL_ADDRES, paramsIn, rootState)
                commit(MAIN_ADDRESS + READ, {
                    data: res.object,
                    fieldInfoList: res.fieldInfoList
                })
                commit(SET_MAIN_PAGINATION_TOTAL, {
                    countPage: res.countPage,
                })
                return res
            }
        } catch (err) {
            return (err)
        }
    },

    [MAIN_ADDRESS + UPDATE]: async({ commit }, paramsIn = null) => {
        try {
            return await api(API_METHODS.UPDATE_ADDRES, paramsIn)
        } catch (err) {
            return (err)
        }
    },

    [MAIN_ADDRESS + DELETE]: async({}, paramsIn = null) => {
        try {
            return await api(API_METHODS.DELETE_ADDRES, paramsIn)
        } catch (err) {
            return (err)
        }
    },
};